import React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useCtaSection } from './hooks';

export const CtaSection: React.FC = () => {
	const {
		actions: { trackSapClick },
	} = useCtaSection();

	return (
		<Button
			data-qa="sidebar-sap-button"
			className="w-full"
			as="a"
			href="/start-a-petition/intro?source_location=petition_guides_article_sidebar"
			variant="primary"
			size="small"
			onClick={trackSapClick}
		>
			<Translate value="corgi.petition_guides_article.page_heading.start_a_petition.button_label" />
		</Button>
	);
};
